import { components } from '@/utils'

import overflow from '@/components/text/overflow'

function renderInput(h) {
  return h(
    components.input,
    {
      class: `${components.radio}__input`,
      attrs: {
        id: this.$_id,
        type: 'radio',
        name: components.radio,
        value: this.value,
        checked: this.isChecked,
        disabled: this.isDisabled
      },
      on: {
        input: this._inputHandler,
        change: this._inputHandler
      }
    }
  )
}
function renderCircle(h) {
  return h(
    'div', {
      class: `${components.radio}__circle`
    }
  )
}
function renderLabel(h) {
  if (this.label) {
    return h(
      'label',
      {
        attrs: {
          for: this.$_id
        },
        class: `${components.radio}__label`
      },
      [
        h(
          overflow,
          {
            props: {
              value: this.label
            }
          }
        )
      ]
    )
  }
}

export default function(h) {
  return h(
    'div',
    {
      class: this.classes,
      on: {
        click: this.clickHandler
      }
    },
    [
      renderInput.call(this, h),
      renderCircle.call(this, h),
      renderLabel.call(this, h)
    ]
  )
}

